import { RulesetResult } from '../../business/rules';
import { PgFiledTaxes2YearsAgoRuleset } from '../../business/ruleset';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';

const { pgFiledTaxes2YearsAgo } = loanFormModel.formField;

export class PgFiledTaxes2YearsAgoValidation implements ValidationSchema {
  public name = pgFiledTaxes2YearsAgo.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = PgFiledTaxes2YearsAgoRuleset;

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'pgFiledTaxes2YearsAgoValidation',
      test: function (value, context) {
        // Principal-level field (not under documents): from[1] = application
        const application: Partial<ApplicationFormValues> =
          this.from?.[1]?.value ?? {};
        const principalId = this.parent?.id;

        const result: RulesetResult =
          PgFiledTaxes2YearsAgoRuleset.setPrincipalId(principalId).evaluate(
            application
          );

        const required = !!(result & RulesetResult.REQUIRED);

        if (
          required &&
          (value === null || value === undefined || value === '')
        ) {
          return this.createError({
            message: 'This field is required',
          });
        }
        return true;
      },
    });
  }
}

export default new Validation(new PgFiledTaxes2YearsAgoValidation());
